import Webinars from './container'

export default Webinars
